// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"65343867","309":"9fb28e23","676":"331c70a8","876":"157a5543"}[chunkId] + ".chunk.js";
};